<template>
  <el-container v-page-title="section.title">
    <!--页面导航-->
    <page-nav :pageNavObj="pageNavObj"></page-nav>
    <!--视频播放-->
    <div>
      <div class="prism-player" id="player-con">
        <!-- 弹题对话框-->
        <question-dialog :questionList="questionList" ref="questionDialog" @submitAnswer="playerPlay"></question-dialog>
      </div>
      <!--验证信息-->
      <div class="need-verify" :style="{visibility: verifyIsHidden ? 'hidden':'visible'}">
        <h2>{{section.title}}</h2>
        <div style="margin-top: 50px">
          <div :style="{display: verifyIsLogin ? 'none':''}">
            <el-button type="primary" @click="toLogin">登录</el-button>
            <br>
            <p style="margin-top: 10px">  登录后才可以观看视频哦 ^ - ^</p>
          </div>
          <div :style="{display: verifyHavCredential ? 'none':''}">
            <el-button type="primary">绑定证书</el-button>
            <br>
            <p style="margin-top: 10px">  绑定证书后才可以观看视频哦 ^ - ^</p>
          </div>
          <div :style="{display: verifyIsBug ? 'none':''}">
            <!--<el-button type="primary" @click="toOrder">购买课程</el-button>-->
            <br>
            <!--<p style="margin-top: 3%;margin-left: 2%">付费后才可以观看视频哦 ^ - ^</p>-->
            <p style="margin-top: 3%;margin-left: 2%">不是该学习班课程哦 ^ - ^</p>
          </div>
        </div>
      </div>
      <el-card class="box-card">
      </el-card>
      <!--课程tab-->
      <course-tab :courseId="course.id" :course="course"></course-tab>
    </div>
    <!-- 拍照-->
    <Camera ref="camera" :courseId="course.id" :sectionId="section.id"></Camera>
    <!--推荐课程-->
    <recommend-course course-type="C"></recommend-course>

  </el-container>
</template>

<script>
  import { initAliyunPlayer } from '@/utils/aliyun-player-init';
  const PageNav = () => import('@/components/course/PageNav');
  const RecommendCourse = () => import('@/components/course/RecommendCourse');
  const Camera = () => import('@/components/course/Camera');
  const QuestionDialog = () => import('@/components/course/QuestionDialog');
  const CourseTab = () => import('@/components/course/CourseTab');
  import {getQuestionInfo, getPtime} from "@/api/continueEdu";
  export default {
    name: 'detail',
    components: {
      CourseTab,
      PageNav,
      RecommendCourse,
      Camera,
      QuestionDialog
    },
    data() {
      return {
        course: {}, // 课程对象
        section: {}, // 小节对象
        videoSource: {}, // 视频播放资源对象
        pageNavObj: {}, // 页面导航对象
        player: null, // 播放器
        activeName: 'second',
        watchTime: 0,  // 视频时间
        // 弹题拍照时间计数器
        timeCalculator: 1,
        timeInterval: 0, // 弹题拍照时间间隔
        alertCount: 0, // 设置弹题的次数
        isBindingKeyDown: false,
        verifyIsHidden: true, // 验证信息是否隐藏
        verifyIsLogin: true, // 验证是否登录
        verifyIsBug: true, //验证是否购买
        verifyHavCredential: true, //验证是否拥有证书
        verfiyCode: '', //验证码
        studyStatus: '', //用户小节学习状态
        lastPlayedTime: 0, // 最后播放时间
        isFree: false, // 是否小节免费

        /* 新改 */
        alertTimeArr: [],  // 弹题时间数组
        alertTime: {},     // 弹题时间
        snapTimeArr: [],   //  抓拍时间数组
        snapTime: null,       // 抓拍时间
        questionList: [],  //  题目列表
        lastProgressTime:null  //上次记录进度时间
      }
    },
    methods: {
      alertQuestion(id) {
        // 暂停视频(计时)
        this.player.pause();
        this.$refs.questionDialog.dialogVisible = true;
        // this.$refs.questionDialog.getQuestionBank();
        this.$refs.questionDialog.getCurrentQuestion(id);
        this.unBindKeyDown();
      },
      openCameraAndQuestion() {
        //弹题
        this.alertQuestion();
        //抓拍上传
        this.$refs.camera.takePhotoAndUpload();
      },
      // 视频播放
      playerPlay() {
        this.player.play();
      },
      // 视频暂停
      playerPause() {
        this.player.pause();
      },
      // 监控视频播放
      onPlayerPlay() {
        if (!this.$refs.camera.isOpenCamera) {
          this.playerPause();
          this.$message.closeAll()
          this.$message.error("视频无法播放,请确保已经开启摄像头!")
          return;
        }
        // 视频播放时，若未进行键盘绑定，则添加键盘绑定
        if (!this.isBindingKeyDown) this.bindingKeyDown();

        //跳转到上次播放位置
        if (parseInt(this.player.getCurrentTime())===0&&parseInt(this.lastPlayedTime) < parseInt(this.player.getDuration()) ) {
          this.player.seek(this.lastPlayedTime);
        }
      },
      // 监控播放时间变化
      onPlayerTimeupdate() {
        if (!this.isFree && this.studyStatus != 'Y') {
          if(this.player.getCurrentTime()-this.watchTime>1){
            this.timeCalculator = Math.floor(this.player.getCurrentTime()/this.timeInterval)+1;
          }else {
            // 旧的弹题抓拍
            // if (this.timeCalculator<=this.alertCount && this.player.getCurrentTime()>this.timeInterval*this.timeCalculator){
            //   this.timeCalculator++;
            //   this.openCameraAndQuestion();
            // }
            // 改弹题抓拍逻辑
            if (this.alertTime.popQuestionTime && this.player.getCurrentTime() >= this.alertTime.popQuestionTime) {
              this.alertQuestion(this.alertTime.id);
              this.alertTime = this.alertTimeArr.length ? this.alertTimeArr.shift() : {}
            }
            // 抓拍
            if (this.snapTime && this.player.getCurrentTime() >= this.snapTime) {
              this.$refs.camera.takePhotoAndUpload();
              this.snapTime = this.snapTimeArr.length ? this.snapTimeArr.shift() : null
            }
          }
        }
        //视频播放前60秒和120秒更改视频结束标识
        if (parseInt(this.player.getCurrentTime()) === parseInt(this.player.getDuration()) - 60 || parseInt(this.player.getCurrentTime()) === parseInt(this.player.getDuration()) - 100) {
          console.log('end')
          this.onPlayerEnded()
        }
        this.watchTime = this.player.getCurrentTime();

        //记录上次播放位置
        if (parseInt(this.player.getCurrentTime())%60===1&&parseInt(this.player.getCurrentTime())!==this.lastProgressTime) {
          this.recordLastPlayTime();
          this.lastProgressTime=parseInt(this.player.getCurrentTime());
        }
      },
      // 截图
      snapshoted(data) {
        var pictureData = data.paramData.base64;
        var downloadElement = document.createElement('a');
        downloadElement.setAttribute('href', pictureData);
        var fileName = 'Huaraun' + Date.now() + '.png';
        downloadElement.setAttribute('download', fileName);
        downloadElement.click();
        pictureData = null;
      },
      // 点击或者键盘空格播放器
      clickOrKeyPlayer(event) {
        if (this.player.getStatus() != 'playing') {
          this.playerPlay();
        }else {
          this.playerPause();
        }
      },
      // 视频播放绑定键盘事件
      bindingKeyDown(){
        this.isBindingKeyDown = true;
        let self = this;
        document.onkeydown = function (e) {
          let keyNum = window.event ? e.keyCode : e.which;
          let playVolume = self.player.getVolume();
          let playTime = self.player.getCurrentTime();
          let duration = self.player.getDuration();
          // 返回false阻止浏览器滚动
          switch (keyNum) {
            case 32:
              self.clickOrKeyPlayer();
              return false;
              break;
            case 38:
              playVolume<0.9 ? self.player.setVolume(playVolume+0.1) : self.player.setVolume(1);
              return false;
              break;
            case 40:
              playVolume>0.1 ? self.player.setVolume(playVolume-0.1) : self.player.setVolume(0);
              return false;
              break;
          }
        }
      },
      // 取消键盘绑定
      unBindKeyDown(){
        this.isBindingKeyDown = false;
        document.onkeydown = null;
      },
      async queryByCourseId(courseId) {
        const {content} = await this.$http.get('/business/web/course/queryById',{params:{courseId:courseId}});
        this.course = content;
        this.initPageNavObj();
        if (this.course.isValidDate){
          if (this.$route.params.sectionId){
            await this.queryBySectionId(this.$route.params.sectionId)
          }
        }else {
          await this.$alert('该时段不允许播放本课程', '提示', {
            confirmButtonText: '确定',
            type: "warning"
          });
        }
      },
      async queryBySectionId(sectionId) {
        const {content} = await this.$http.get('/business/web/section/queryById',{params:{sectionId:sectionId}});
        this.section = content;
        // 查询小节资源
        await this.queryByTarget();

        this.initPageNavObj();
      },
      async queryByTarget() {
        const {code,content} = await this.$http.post('/business/web/section/queryByTarget',
          {'sectionId':this.section.id,
            'targetId':this.section.targetId,
            'targetType':this.section.targetType,
            'courseType':'C'});
        if (code === '2002') {
          this.verifyIsHidden = false;
          this.verifyIsLogin = false;
        }else if(code=== '2003') {
          this.verifyIsHidden = false;
          this.verifyIsBug = false;
        }else if(code === '2001') {
          this.isFree = true;
          // 初始化阿里云播放器
          this.videoSource = content.videoSource;
          this.initVod();
        }else if(code === '2000') {
          this.verfiyCode = code;
          // SessionStorage进行存储最后播放时间与记忆播放组件交互
          if (!this.isFree && content.lastPlayedTime != undefined && content.lastPlayedTime!= 0 ) {
            SessionStorage.set("lastPlayedTime",content.lastPlayedTime);
            this.lastPlayedTime = content.lastPlayedTime;
          }else {
            this.lastPlayedTime = 0;
            SessionStorage.remove("lastPlayedTime");
          }
          this.studyStatus = content.userSectionStudyStatus;
          // 初始化阿里云播放器
          this.videoSource = content.videoSource;
          this.initVod();
          // 初始化弹题计数器和弹题次数
          if (!this.isFree && this.studyStatus != 'Y') {
            this.initTimeCalculatorAndAlertCount(parseFloat(content.duration));
          }

        }
      },
      // 初始化阿里云播放器
      initVod() {
        let self = this;
        //初始化阿里云播放器(播放地址播放)
        self.player = initAliyunPlayer(self.videoSource);
        //开始播放时
        self.player.on('play', e => { self.onPlayerPlay(); });
        //播放时间更新时
        self.player.on('timeupdate', e => { self.onPlayerTimeupdate(); });
        // 截图
        self.player.on('snapshoted', data => {self.snapshoted(data); });
        // 当视频播放完毕
        self.player.on('ended', data => {self.onPlayerEnded(); });
        //禁止拖动
        document.getElementsByClassName('prism-progress')[0].style.pointerEvents = 'none';
        // 禁用加速
        document.getElementsByClassName('prism-setting-speed')[0].style.display = 'none';
        // 禁用视频加载
        //  document.getElementsByClassName('prism-loading')[0].firstChild.style.display = 'none';
        // 绑定视频点击事件
        document.querySelector('#player-con>video').onclick = this.clickOrKeyPlayer;
        // 绑定页面点击事件
        document.onclick = function(e){
          // 判断视频是否正在播放
          if(self.player.getStatus() != 'playing'){
            // 判断是否已绑定键盘
            if (self.isBindingKeyDown){
              // 判断是否点击非视频区域
              if(!document.querySelector('#player-con').contains(e.target)){
                // 解除键盘绑定
                self.unBindKeyDown();
              }
            }
          }
        };
      },
      initTimeCalculatorAndAlertCount(duration) {
        // 初始化趟次次数，如果大于等于4分钟，弹题次数为4次，如果小于4分钟，每分钟一次
        const count = Math.floor(duration / 60);
        if (count >= 4) {
          this.alertCount = 4;
        }else if (count == 0){
          this.alertCount = 1;
        }else {
          this.alertCount = count;
        }
        // else {
        //   this.alertCount = count + 1;
        // }
        // 最后一次是不会弹题，所以计算时要+1
        // const time = Math.round(parseInt(duration)/(parseInt(this.alertCount)+ parseInt('1')));
        this.timeInterval = duration/(parseInt(this.alertCount)+1);
        // +1 是防止视频结束了还会弹题
        // this.timeCalculator =  time + parseInt('1');
        // this.timeInterval = time;
      },
      initPageNavObj() {
        this.pageNavObj = {
          courseType: this.course.courseType,
          courseId: this.course.id,
          courseName: this.course.name,
          sectionTitle: this.section.title
        }
      },
      toLogin() {
        this.$router.push({ path: '/login' });
      },
      toOrder() {
        this.$router.push({ path: `/home/orderConfirm/${this.course.id}`});
      },
      // 页面刷新或者关闭
      refreshAndClose() {
        // 当非免费观看 记录最后播放时间
        if (!this.isFree && this.watchTime>0) {
          this.recordLastPlayTime();
        }
      },
      async recordLastPlayTime() {
        await this.$http.post('/business/web/userSection/recordLastTimeAndUpdatimeStatus',
          {"sectionId":this.section.id,"lastPlayTime":parseInt(this.player.getCurrentTime())});
      },
      async onPlayerEnded() {
        // 当学习状态未完成，修改学习状态
        if (!this.isFree && this.studyStatus != 'Y') {
          await this.$http.post('/business/web/userSection/completeSectionStudy',
            {"courseId":this.course.id,"sectionId":this.section.id});
        }
      },
      //  获取题目信息
      getQuestion(sectionId) {
        getQuestionInfo(sectionId).then(res => {
          if (res.success) {
            let data = res.content
            this.questionList = data.map(item => {
              this.alertTimeArr.push({
                popQuestionTime: item.popQuestionTime,
                id: item.questionBankId
              })
              return item
            })
            this.alertTimeArr.sort((a, b) => a.popQuestionTime - b.popQuestionTime)
            this.alertTime = this.alertTimeArr.length > 0 ? this.alertTimeArr.shift() : {}
          }
        })
      },
      // 获取抓拍时间
      getSnapTimes(sectionId) {
        getPtime(sectionId).then(res => {
          if (res.content){
            this.snapTimeArr = res.content.split(',')
            this.snapTime = this.snapTimeArr.shift()
          }
        })
      },
    },
    beforeRouteUpdate(to, from, next){
      if (this.$refs["camera"].video.srcObject ){
        this.$refs["camera"].video.srcObject.getTracks().forEach(function (media) {
          media.stop();
        })
      }
      next();
    },
    // 路由更新
    beforeRouteLeave (to, from, next) {
      if (!this.isFree && this.player && this.player.getCurrentTime()>0) {
        this.recordLastPlayTime();
      }
      // 离开视频播放页面，取消键盘绑定
      this.unBindKeyDown();
      document.onclick = null;
      if (this.$refs["camera"].video.srcObject ){
        this.$refs["camera"].video.srcObject.getTracks().forEach(function (media) {
          media.stop();
        })
      }
      next();
    },


    created() {
      // 监控页面刷新和关闭
      window.addEventListener('beforeunload', e => this.refreshAndClose(e));
    },
    mounted() {
      let courseId = this.$route.params.courseId;
      let sectionId = this.$route.params.sectionId;
      this.getQuestion(sectionId)
      this.getSnapTimes(sectionId)
      this.queryByCourseId(courseId);
    },
    watch: {
      watchTime(newVal,oldVal) {
        // 说明点击了跳转
        if (newVal - oldVal > 1) {
          console.log(newVal)
          // 如果点击了跳转 跳转之间的弹题和抓拍过滤掉
          this.alertTimeArr = this.alertTimeArr.filter(item => item.popQuestionTime > newVal)
          if (this.alertTime.popQuestionTime < newVal) {
            this.alertTime = this.alertTimeArr.length ? this.alertTimeArr.shift() : {}
          }
          this.snapTimeArr = this.snapTimeArr.filter(item => item > newVal)
          if (this.snapTime < newVal) {
            this.snapTime = this.snapTimeArr.length ? this.snapTimeArr.shift() : null
          }
        }
      }
      // watchTime(newVal,oldVal) {
      //   // 说明点击了跳转
      //   if (newVal - oldVal > 1) {
      //     console.log(132)
      //     this.timeCalculator = parseInt(this.lastPlayedTime) + parseInt(this.timeInterval);
      //   }
      //   if (this.watchTime > this.timeCalculator) {
      //     this.timeCalculator = parseInt(this.watchTime) + parseInt(this.timeInterval);
      //     // 调用弹题和拍照
      //     if (!this.isFree && this.studyStatus != 'Y') {
      //       this.openCameraAndQuestion();
      //     }
      //   }
      // }
    }
  }
</script>

<style scoped>
  .el-container {
    width: 1098px;
    min-width: 1098px;
    margin: 35px auto 0 auto;
  }
  .prism-player {
    width: 1099px;
    height: 619px;
  }
  .need-verify {
    text-align: center;
    color: #0b76de;
    position: relative;
    top: -450px;
    height: 175px;
    visibility: hidden;
  }
  .box-card {
    width: 100%;
    margin-top: -195px;
    height: 60px;
  }
</style>
